import { LayoutDataSource } from '@n7-frontend/core';
import { HttpHeaders } from '@angular/common/http';

export class HomeLayoutDS extends LayoutDataSource {
  private communication;
  private router;

  private data_cache = { id: '', data: {} };
  
  onInit(payload) {
    this.communication = payload.communication;
    this.router = payload.router;

    this.router.paramMap.subscribe(x => {
      const id = x.get('id') ;
      const navPage = x.get('nav');

      if (this.data_cache.id === id) {
        // this.one('dc-nav').update({ navData: this.data_cache.data, cName: companyName, nav: navPage, cId: id });
      } else {

        this.communication.request$('getUserData', {
          urlParams: id,
          params: { linistryID: id },
          onError: (error) => {
            console.log('getUser error', error);
            switch (error.status) {
              case 404:
                payload.navRouter.navigate(['']);
                break;
              case 500:
                payload.navRouter.navigate(['']); // go home
                break;
              default:
                if (error.status || error.status === 0) {
                  payload.navRouter.navigate(['error']); // GO error????
                }
                break;
            }
          },
  
        }).subscribe(data => {
          if (navPage.indexOf('print') === 0) {
            data.noAnimation = true;
          }
          
          this.data_cache.id = id;
          this.data_cache.data = data;

          this.one('dc-home').update(data);
          this.one('title').update(data);
          this.one('personal-info-metadata').update(data);
          this.one('jobs-table').update(data);
          this.one('real-estates-table').update(data);
          this.one('main-shares-table').update(data);
          this.one('other-shares-table').update(data);
          this.one('revenues-chart').update(data);
          this.one('profit-chart').update(data);
          this.one('ebitda-chart').update(data);
          this.one('profit-dataw').update(data);
          this.one('revenues-dataw').update(data);
          this.one('ebitda-dataw').update(data);
          this.one('profit-ititle').update(data);
          this.one('revenues-ititle').update(data);
          this.one('ebitda-ititle').update(data);
          this.one('centrality-score-chart').update(data);
          this.one('cgrp15-chart').update(data);
          this.one('cgrp4-chart').update(data);
          this.one('export-pdf').update({ data: data, communication: this.communication, linistryID: id, auth: payload.auth });
        });
      }

    });

  }
}

